var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from "clsx";
import React, { forwardRef } from "react";
import { Detail } from "../typography/index.js";
const Bubble = forwardRef((_a, ref) => {
    var { children, className, name, timestamp, toptextPosition } = _a, rest = __rest(_a, ["children", "className", "name", "timestamp", "toptextPosition"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: cl("navds-chat__bubble", className) }, rest),
        (timestamp || name) && (React.createElement("h3", { className: cl(`navds-chat__top-text`, toptextPosition && `navds-chat__top-text--${toptextPosition}`) },
            name && React.createElement(Detail, { as: "span" }, name),
            name && timestamp && (React.createElement(Detail, { as: "span", "aria-hidden": true }, "\u2022")),
            timestamp && React.createElement(Detail, { as: "span" }, timestamp))),
        children));
});
export default Bubble;
//# sourceMappingURL=Bubble.js.map